import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/toast'
import { useUIStore } from '@/stores/uiStore'

export function Toaster() {
  const { toasts, removeToast } = useUIStore()

  return (
    <ToastProvider>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          variant={toast.variant}
          onOpenChange={(open) => {
            if (!open) removeToast(toast.id)
          }}
        >
          {toast.variant === 'delete_success' ? (
            <div className="-m-4 -mr-6 mb-0">
              <div className="bg-destructive px-4 py-1.5">
                <ToastTitle className="text-destructive-foreground">{toast.title}</ToastTitle>
              </div>
              <div className="px-4 pt-2 pb-0">
                {toast.description && <ToastDescription>{toast.description}</ToastDescription>}
              </div>
            </div>
          ) : (
            <div className="grid gap-1">
              <ToastTitle>{toast.title}</ToastTitle>
              {toast.description && (
                <ToastDescription>{toast.description}</ToastDescription>
              )}
            </div>
          )}
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport />
    </ToastProvider>
  )
}
